import { App, plugin } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress'
import LaravelPermissionToVueJS from '../js/LaravelPermissions'
import Vue from 'vue'

InertiaProgress.init({
  includeCSS: true,
  showSpinner: true,
  color: "#00A1FF"
})

Vue.use(plugin)
Vue.use(LaravelPermissionToVueJS)

const el = document.getElementById('app')

new Vue({
  render: h => h(App, {
    props: {
      initialPage: JSON.parse(el.dataset.page),
      resolveComponent: name => require(`@/Pages/${name}`).default,
    },
  }),
  mounted() {
    if (process.env.NODE_ENV !== 'production') {
      console.log(JSON.parse(el.dataset.page).props);
    }
  },
}).$mount(el)